<div class="content-container" role="main" [attr.aria-busy]="loading ? 'true' : 'false'" aria-live="assertive">
  @if (methods && !loading) {
    <div class="flex card-max-width">
      @if (mainTheme !== themeType.Custom) {
        <id-card>
          <ng-container *ngTemplateOutlet="authenticationMethodContent"></ng-container>
        </id-card>
      } @else {
        <div class="custom-card">
          <ng-container *ngTemplateOutlet="authenticationMethodContent"></ng-container>
        </div>
      }
    </div>
  }

  @if (loading) {
    <div class="flex">
      <div class="flex flex-center margin-50">
        <div class="loading-indicator-large" role="progressbar"></div>
      </div>
    </div>
  }
</div>

<ng-template #authenticationMethodContent>
  <div class="flex flex-column flex-align-center">
    <h1 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }}">{{ getTitle() }}</h1>
    <h2 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }} ids-mt-3 ids-mb-5">
      {{ clientInfo?.organizationName }}
    </h2>
    <h3 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-l' }} ids-mb-5">
      {{ getTypeText() }}
    </h3>
  </div>

  @for (method of methods; track $index) {
    <button class="auth-button ids-mb-3" (click)="selectMethod(method, false)">
      <div class="button-container">
        <div>
          @if (method.type === 'MTLS') {
            <img src="assets/images/mtls-icon.svg" alt="MTLS ikon" />
          } @else if (method.type === 'SITHS_EID_OTHER_DEVICE' || method.type === 'SITHS_EID_SAME_DEVICE') {
            <img src="assets/images/siths-eid-background-icon.svg" alt="SITHS eID ikon" />
          } @else if (method.type === 'BANK_ID_OTHER_DEVICE' || method.type === 'BANK_ID_SAME_DEVICE') {
            <img src="assets/images/logo-bank-id.svg" alt="BankID icon" />
          } @else if (method.type === 'FREJA_EID_OTHER_DEVICE' || method.type === 'FREJA_EID_SAME_DEVICE') {
            <img src="assets/images/FRoundedIndigo.svg" alt="Freja eID F icon" />
          } @else if (method.type === 'TOTP') {
            <img src="assets/images/inera-logo.svg" alt="Timed one time password icon" />
          } @else if (method.type === 'EIDAS') {
            <img src="assets/images/inera-logo.svg" alt="eIDAS       icon" />
          } @else if (method.type === 'FREJA_EID_ORG_OTHER_DEVICE' || method.type === 'FREJA_EID_ORG_SAME_DEVICE') {
            <img src="assets/images/FRoundedIndigo.svg" alt="Freja eID Organization F icon" />
          }
        </div>
        <div class="ids-ml-5">
          <span [innerHTML]="getMethodText(method.name)"></span>
        </div>
      </div>
    </button>
  }
</ng-template>
